import VisitorLogsDataTable from "../../../components/dataTable/tables/visitor/VisitorLogsDataTable";

function VisitorsLogPageView() {
  return <VisitorLogsDataTable />;
}

export default VisitorsLogPageView;
